import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { SceneEditorProps } from "./SceneEditor";
const SceneEditor = lazy(() => import("./SceneEditor").then(module => ({ default: module.SceneEditor })));
/** The storyboard's film strip hosts the editor under the scene; elsewhere it is a drawer. */
export const INLINE_SCENE_EDITOR = "scene-editor-inline";
export function mountSceneEditor(slot: HTMLElement | null, props: SceneEditorProps, outlet = "drawer") {
  setStudioView(outlet, "scene-editor", <SceneEditor
      key={`${props.model.projectId}:${props.model.sceneId}`}
      {...props}
      inline={outlet === INLINE_SCENE_EDITOR}
    />);
}
